import React from "react";
import PropTypes from "prop-types";
import { HiLocationMarker } from "react-icons/hi";
import { RegisterNewAddress, ConfirmAndCancel } from "./styles";

import { swalCustom } from "../../utils/functions";

import AddressComponent from "../../components/AddressComponent";
import ModalApp from "../../components/ModalApp";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";

export default function PersonalAddressList({
  addresses,
  onClickDelAddress,
  setAddress,
  setOpen,
  address,
  open,
  handleEndereco,
  screenName = "minha-conta"
}) {
  const handleDeleteAddress = (addressUuid) => {
    trackClick({
      title: "excluir",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });
    
    swalCustom
      .fire({
        html: '<p class="fw-bold fs-5 mb-0">Deseja excluir este endereço?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "question",
      })
      .then((result) => {
        if (result.isConfirmed) {
          onClickDelAddress(addressUuid);
        } else if (result.dismiss) {
          trackClick({
            title: "cancelar-exclusao-endereco",
            contentType: "atualizar-dados-do-endereco",
            screenName,
            tagId: tagIdFromLegacySuffix("07"),
          });
        }
      });
  };

  const editarEndereco = (address) => {
    trackClick({
      title: "alterar",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });
    
    setAddress(address);
    setOpen(true);
  };

  return (
    <>
      <ModalApp show={open} handleModal={() => {
        trackClick({
          title: "fechar-modal",
          contentType: "cadastrar-novo-endereco",
          screenName,
          tagId: tagIdFromLegacySuffix("07"),
        });
        setOpen(false);
      }}>
        <AddressComponent
          onConfirm={handleEndereco}
          onCancel={() => setOpen(false)}
          address={address}
        />
      </ModalApp>
      <RegisterNewAddress>
        {addresses.length > 0 ? (
          addresses
            .sort((a, b) => (b.main ? 1 : 0) - (a.main ? 1 : 0))
            .map((address, index) => (
            <div key={address.uuid || index}>
              <div className="registerNewAddressHeader">
                <p className="mb-0 font-wl-500 text-mg d-flex align-items-center gap-1">
                  {address.label || "Principal"}
                  {address.fixed === 1 && <HiLocationMarker color="black" />}
                </p>
                <ConfirmAndCancel>
                  {address.fixed === 0 && (
                    <>
                      <button
                        className="text-decoration-underline text-xs default-button"
                        onClick={() => editarEndereco(address)}
                        type="button"
                      >
                        ALTERAR
                      </button>
                      <button
                      className="btn link-cancel-wl text-decoration-underline text-xs"
                      onClick={() => handleDeleteAddress(address.uuid)}
                      type="button"
                    >
                      EXCLUIR
                    </button>
                    </>
                  )}
                </ConfirmAndCancel>
              </div>
              <div
                className="d-flex justify-content-between"
                style={{ width: "95%" }}
              >
                <div className="information text-justify font-wl-400 text-mg">
                  <span>
                    {address.streetName}, {address.number}
                  </span>
                  <span>
                    {address.neighborhood}
                    {address.complement ? `, ${address.complement}` : ""}
                  </span>
                  <span>
                    {address.city}, {address.state} - {address.zipCode}
                  </span>
                </div>
              </div>
               {address.fixed === 1 && (
                 <>
                   <div className="mt-4" style={{ width: "70%" }}>
                     <p className="text-xs mb-1 text-text_primary_color italic">
                       Este é seu endereço de cadastro no Safra. Para altera-lo é necessário entrar em contato com o banco.
                     </p>
                   </div>
                   <hr className="my-4" style={{ borderTop: "1px solid #05092229", width: "100%" }} />
                 </>
               )}
             </div>
          ))
        ) : (
          <span className="information">Nenhum endereço cadastrado</span>
        )}
      </RegisterNewAddress>
    </>
  );
}

PersonalAddressList.propTypes = {
  addresses: PropTypes.array,
  onClickDelAddress: PropTypes.func,
  setAddress: PropTypes.func,
  setOpen: PropTypes.func,
  address: PropTypes.object,
  open: PropTypes.bool,
  handleEndereco: PropTypes.func,
  screenName: PropTypes.string,
};
